import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { PreloadState } from './types'

export const initialState: PreloadState = {
  preloaded: false,
}

const preloadSlice = createSlice({
  name: 'preload',
  initialState,
  reducers: {
    /**
     * Triggers the preload saga. The saga assumes a valid exchange token is available from the
     * host (or fails). To boot the SDK without doing token exchange (e.g. VoIP / push-notification
     * cold-start where the host has no fresh exchange token), the native side calls `start` with
     * `skipTokenExchange = true` (or explicit `preload = false`) and that path skips dispatching
     * this action. The JS startup saga then reuses the persisted Dialogue auth token (paired
     * with the `skipTokenExchange` initial view prop) instead of doing a fresh token exchange.
     */
    preload: () => {},
    preloadSuccess: (state) => {
      state.preloaded = true
    },
    preloadFailure: (state, _action: PayloadAction<Error | undefined>) => {
      state.preloaded = false
    },
    resetPreload: (state) => {
      state.preloaded = false
    },
  },
})

export const preloadActions = preloadSlice.actions

export default preloadSlice.reducer
